export type SupportedCurrency = 'CZK' | 'EUR' | 'USD' | 'GBP' | 'PLN' | 'HUF' | 'CHF' | 'Kč';

export const SUPPORTED_CURRENCIES: SupportedCurrency[] = [
  'CZK',
  'EUR',
  'USD',
  'GBP',
  'PLN',
  'HUF',
  'CHF',
  'Kč',
];

export const CURRENCY_LOCALE_MAP: Record<SupportedCurrency, string> = {
  CZK: 'cs-CZ',
  Kč: 'cs-CZ',
  EUR: 'de-DE',
  USD: 'en-US',
  GBP: 'en-GB',
  PLN: 'pl-PL',
  HUF: 'hu-HU',
  CHF: 'de-CH',
};
